const number = "number";
const text = "text";

const titleCase = (value) =>
  String(value || "")
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const ASSET_CARD_DEVICE_DETAILS_FIELDS = [
  { value: "asset_name", label: "Asset Name", path: ["asset_name"], group: "Asset Card" },
  { value: "asset_code", label: "Asset Code", path: ["asset_code"], group: "Asset Card" },
  { value: "category_subcategory", label: "Category", path: ["category_subcategory"], group: "Asset Card" },
  { value: "brand", label: "Brand", path: ["brand"], group: "Asset Card" },
  { value: "model_number", label: "Model", path: ["model_number"], group: "Asset Card" },
  { value: "serial_number", label: "Serial", path: ["serial_number"], group: "Asset Card" },
  { value: "type", label: "Asset Type", path: ["type"], group: "Asset Card" },
  { value: "manufacturer", label: "Manufacturer", path: ["manufacturer"], group: "Asset Card" },
  { value: "manufacture_date", label: "Manufacture Date", path: ["manufacture_date"], group: "Asset Card" },
  { value: "location", label: "Location", path: ["location"], group: "Asset Card" },
  { value: "ac_capacity", label: "AC Capacity", path: ["ac_capacity"], group: "Asset Card" },

  { value: "capacity_rating", label: "Capacity Rating", path: ["OperationalData", "capacity_rating"], group: "Operational Data" },
  { value: "power", label: "Power", path: ["OperationalData", "power"], group: "Operational Data" },
  { value: "voltage", label: "Voltage", path: ["OperationalData", "voltage"], group: "Operational Data" },
  { value: "current", label: "Current", path: ["OperationalData", "current"], group: "Operational Data" },
  { value: "connection_type", label: "Connection Type", path: ["OperationalData", "connection_type"], group: "Operational Data" },
  { value: "efficiency_percent", label: "Efficiency %", path: ["OperationalData", "efficiency_percent"], group: "Operational Data" },
  { value: "running_hours_counter", label: "Running Hours", path: ["OperationalData", "running_hours_counter"], group: "Operational Data" },
  { value: "power_supply", label: "Power Supply", path: ["OperationalData", "power_supply"], group: "Operational Data" },
  { value: "kw_thermal", label: "kW Thermal", path: ["OperationalData", "kw_thermal"], group: "Operational Data" },
  { value: "kw_electrical", label: "kW Electrical", path: ["OperationalData", "kw_electrical"], group: "Operational Data" },
  { value: "capacity_ton", label: "Capacity Ton", path: ["OperationalData", "capacity_ton"], group: "Operational Data" },
  { value: "efficiency", label: "Efficiency", path: ["OperationalData", "efficiency"], group: "Operational Data" },
  { value: "number_of_compressors", label: "No. Compressors", path: ["OperationalData", "number_of_compressors"], group: "Operational Data" },
  { value: "compressors", label: "Compressors", path: ["OperationalData", "compressors"], group: "Operational Data" },
  { value: "number_of_indoor_fans", label: "No. Indoor Fans", path: ["OperationalData", "number_of_indoor_fans"], group: "Operational Data" },
  { value: "indoor_fans", label: "Indoor Fans", path: ["OperationalData", "indoor_fans"], group: "Operational Data" },
  { value: "number_of_outdoor_fans", label: "No. Outdoor Fans", path: ["OperationalData", "number_of_outdoor_fans"], group: "Operational Data" },
  { value: "outdoor_fans", label: "Outdoor Fans", path: ["OperationalData", "outdoor_fans"], group: "Operational Data" },
  { value: "coverage_area", label: "Coverage Area", path: ["OperationalData", "coverage_area"], group: "Operational Data" },
  { value: "room_size", label: "Room Size", path: ["OperationalData", "room_size"], group: "Operational Data" },
  { value: "capacity_cfm", label: "CFM", path: ["OperationalData", "capacity_cfm"], group: "Operational Data" },
  { value: "light_intensity", label: "Light Intensity", path: ["OperationalData", "light_intensity"], group: "Operational Data" },
  { value: "refrigerant_type", label: "Refrigerant Type", path: ["OperationalData", "refrigerant_type"], group: "Operational Data" },
  { value: "actuator_type", label: "Actuator Type", path: ["OperationalData", "actuator_type"], group: "Operational Data" },
  { value: "related_current", label: "Related Current", path: ["OperationalData", "related_current"], group: "Operational Data" },
  { value: "vav_width", label: "VAV Width", path: ["OperationalData", "vav_width"], group: "Operational Data" },
  { value: "vav_length", label: "VAV Length", path: ["OperationalData", "vav_length"], group: "Operational Data" },
  { value: "motor_capacity", label: "Motor Capacity", path: ["OperationalData", "motor_capacity"], group: "Operational Data" },
  { value: "rated_current", label: "Rated Current", path: ["OperationalData", "rated_current"], group: "Operational Data" },
  { value: "flow_m3h", label: "Flow m3/h", path: ["OperationalData", "flow_m3h"], group: "Operational Data" },
  { value: "rated_flow_rate_m3h", label: "Rated Flow Rate", path: ["OperationalData", "rated_flow_rate_m3h"], group: "Operational Data" },
  { value: "rated_rpm", label: "Rated RPM", path: ["OperationalData", "rated_rpm"], group: "Operational Data" },
  { value: "max_operating_pressure", label: "Max Operating Pressure", path: ["OperationalData", "max_operating_pressure"], group: "Operational Data" },
  { value: "control_type", label: "Control Type", path: ["OperationalData", "control_type"], group: "Operational Data" },
  { value: "head_m3", label: "Head m3", path: ["OperationalData", "head_m3"], group: "Operational Data" },
  { value: "max_water_temp", label: "Max Water Temp", path: ["OperationalData", "max_water_temp"], group: "Operational Data" },
  { value: "rated_capacity", label: "Rated Capacity", path: ["OperationalData", "rated_capacity"], group: "Operational Data" },
  { value: "rated_voltage", label: "Rated Voltage", path: ["OperationalData", "rated_voltage"], group: "Operational Data" },
  { value: "max_rated_current", label: "Max/Rated Current", path: ["OperationalData", "max_rated_current"], group: "Operational Data" },
  { value: "rated_power_factor", label: "Rated Power Factor", path: ["OperationalData", "rated_power_factor"], group: "Operational Data" },
  { value: "rated_frequency", label: "Rated Frequency", path: ["OperationalData", "rated_frequency"], group: "Operational Data" },
  { value: "fuel_tank_capacity", label: "Fuel Tank Capacity", path: ["OperationalData", "fuel_tank_capacity"], group: "Operational Data" },
  { value: "fuel_type", label: "Fuel Type", path: ["OperationalData", "fuel_type"], group: "Operational Data" },
  { value: "total_pv_capacity_dc", label: "Total PV Capacity DC", path: ["OperationalData", "total_pv_capacity_dc"], group: "Operational Data" },
  { value: "inverter_ac_rating", label: "Inverter AC Rating", path: ["OperationalData", "inverter_ac_rating"], group: "Operational Data" },
  { value: "tilt_azimuth_angles", label: "Tilt/Azimuth Angles", path: ["OperationalData", "tilt_azimuth_angles"], group: "Operational Data" },
  { value: "panel_size", label: "Panel Size", path: ["OperationalData", "panel_size"], group: "Operational Data" },
  { value: "battery_capacity", label: "Battery Capacity", path: ["OperationalData", "battery_capacity"], group: "Operational Data" },
  { value: "tank_type", label: "Tank Type", path: ["OperationalData", "tank_type"], group: "Operational Data" },
  { value: "shape", label: "Shape", path: ["OperationalData", "shape"], group: "Operational Data" },
  { value: "length", label: "Length", path: ["OperationalData", "length"], group: "Operational Data" },
  { value: "width", label: "Width", path: ["OperationalData", "width"], group: "Operational Data" },
  { value: "height", label: "Height", path: ["OperationalData", "height"], group: "Operational Data" },

  { value: "installation_date", label: "Installation Date", path: ["MaintenanceLifecycle", "installation_date"], group: "Maintenance Lifecycle" },
  { value: "warranty_expiry_date", label: "Warranty Expiry Date", path: ["MaintenanceLifecycle", "warranty_expiry_date"], group: "Maintenance Lifecycle" },
  { value: "condition_status", label: "Condition", path: ["MaintenanceLifecycle", "condition_status"], group: "Maintenance Lifecycle" },
  { value: "technical_evaluation", label: "Technical Evaluation", path: ["MaintenanceLifecycle", "technical_evaluation"], group: "Maintenance Lifecycle" },
  { value: "criticality_level", label: "Criticality", path: ["MaintenanceLifecycle", "criticality_level"], group: "Maintenance Lifecycle" },
  { value: "estimated_life_cycle_years", label: "Estimated Life Cycle", path: ["MaintenanceLifecycle", "estimated_life_cycle_years"], group: "Maintenance Lifecycle" },
  { value: "last_maintenance_date", label: "Last Maintenance", path: ["MaintenanceLifecycle", "last_maintenance_date"], group: "Maintenance Lifecycle" },
  { value: "next_maintenance_due", label: "Next Maintenance Due", path: ["MaintenanceLifecycle", "next_maintenance_due"], group: "Maintenance Lifecycle" },
  { value: "o_and_m_vendor", label: "O&M Vendor", path: ["MaintenanceLifecycle", "o_and_m_vendor"], group: "Maintenance Lifecycle" },
  { value: "depreciation", label: "Depreciation", path: ["MaintenanceLifecycle", "depreciation"], group: "Maintenance Lifecycle" },

  { value: "supplier_vendor", label: "Supplier", path: ["FinancialOwnership", "supplier_vendor"], group: "Financial Ownership" },
  { value: "department_owner", label: "Department Owner", path: ["FinancialOwnership", "department_owner"], group: "Financial Ownership" },
  { value: "purchase_cost", label: "Purchase Cost", path: ["FinancialOwnership", "purchase_cost"], group: "Financial Ownership" },
  { value: "annual_om_cost", label: "Annual O&M Cost", path: ["FinancialOwnership", "annual_om_cost"], group: "Financial Ownership" },

  { value: "monitored_parameters", label: "Monitored Parameters", path: ["IotMonitoring", "monitored_parameters"], group: "IoT Monitoring" },
  { value: "alert_thresholds", label: "Alert Thresholds", path: ["IotMonitoring", "alert_thresholds"], group: "IoT Monitoring" },
  { value: "integration_protocol", label: "Integration Protocol", path: ["IotMonitoring", "integration_protocol"], group: "IoT Monitoring" },
];

export const ASSET_CARD_DEVICE_DETAILS_FIELD_VALUES = ASSET_CARD_DEVICE_DETAILS_FIELDS.map((field) => field.value);

export const DEFAULT_ASSET_CARD_CONFIG = {
  deviceDetailsMaxItems: 4,
  deviceDetailsFields: ASSET_CARD_DEVICE_DETAILS_FIELD_VALUES,
  categories: [
    {
      value: "AC",
      label: "AC",
      assetTypes: [
        "AC - Package",
        "AC - Duct Split",
        "AC - VAV",
        "AC - Chiller",
        "AC - AHU",
        "AC- FAHU",
        "AC - Split Unit",
        "AC - Cassette",
        "AC - CRAC",
        "AC - Stand Unit",
        "FCU",
      ],
    },
    {
      value: "Pump",
      label: "Pump",
      assetTypes: ["Submersible Pump", "Booster Pump", "Fire Pump System", "Transfer Pump"],
    },
    { value: "Solar System", label: "Solar System", assetTypes: [] },
    { value: "Generator", label: "Generator", assetTypes: [] },
    { value: "Water Tank", label: "Water Tank", assetTypes: [] },
  ],
};

const FIELD_MAP = new Map(ASSET_CARD_DEVICE_DETAILS_FIELDS.map((field) => [field.value, field]));

export const normalizeStringList = (value) =>
  (Array.isArray(value) ? value : [])
    .map((item) => (typeof item === "string" ? item : item?.value || item?.label || ""))
    .map((item) => String(item).trim())
    .filter(Boolean);

export const getAssetCardDeviceDetailsField = (fieldValue) => {
  const value = String(fieldValue || "").trim();
  if (!value) return null;
  return FIELD_MAP.get(value) || {
    value,
    label: titleCase(value),
    path: [value],
    group: "Custom / Future Field",
  };
};

export const getAssetCardDeviceDetailsFieldOptions = (fields = ASSET_CARD_DEVICE_DETAILS_FIELD_VALUES) => {
  const seen = new Set();
  return normalizeStringList(fields)
    .map(getAssetCardDeviceDetailsField)
    .filter(Boolean)
    .filter((field) => {
      if (seen.has(field.value)) return false;
      seen.add(field.value);
      return true;
    });
};

export const normalizeAssetCardConfig = (value = {}) => {
  const rawMaxItems = Number(value.deviceDetailsMaxItems);
  const deviceDetailsMaxItems = Number.isFinite(rawMaxItems)
    ? Math.min(8, Math.max(1, Math.trunc(rawMaxItems)))
    : DEFAULT_ASSET_CARD_CONFIG.deviceDetailsMaxItems;
  const rawCategories = Array.isArray(value.categories) ? value.categories : DEFAULT_ASSET_CARD_CONFIG.categories;
  const deviceDetailsFields = normalizeStringList(value.deviceDetailsFields);
  const categories = rawCategories
    .map((category) => {
      const label = String(category?.label || category?.value || "").trim();
      const categoryValue = String(category?.value || label).trim();
      if (!categoryValue) return null;
      return {
        value: categoryValue,
        label: label || categoryValue,
        assetTypes: normalizeStringList(category?.assetTypes),
      };
    })
    .filter(Boolean);

  return {
    deviceDetailsMaxItems,
    deviceDetailsFields: deviceDetailsFields.length ? deviceDetailsFields : DEFAULT_ASSET_CARD_CONFIG.deviceDetailsFields,
    categories: categories.length ? categories : DEFAULT_ASSET_CARD_CONFIG.categories,
  };
};

export const getAssetTypesForCategory = (config, categoryValue) =>
  (normalizeAssetCardConfig(config).categories.find((category) => category.value === categoryValue)?.assetTypes || [])
    .map((value) => ({ value, label: value }));

export const parseOptionalNumber = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : value;
};

export const parseOptionalInteger = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? Math.max(0, Math.trunc(numberValue)) : value;
};

export const COMPRESSOR_FIELDS = [
  { name: "voltage", label: "Voltage", type: number },
  { name: "running_current", label: "Running Current", type: number },
  { name: "starting_current", label: "Starting Current", type: number },
  { name: "power", label: "Power", type: number },
  { name: "hp", label: "HP", type: number },
  { name: "rla", label: "RLA", type: number },
  { name: "lra", label: "LRA", type: number },
  { name: "fla", label: "FLA", type: number },
];

export const FAN_FIELDS = [
  { name: "voltage", label: "Voltage", type: number },
  { name: "running_current", label: "Running Current", type: number },
  { name: "starting_current", label: "Starting Current", type: number },
  { name: "power", label: "Power", type: number },
  { name: "rpm", label: "RPM", type: number },
  { name: "hp", label: "HP", type: number },
];

export const OPERATIONAL_FIELD_DEFINITIONS = {
  AC: [
    { name: "power_supply", label: "Power Supply", type: number },
    { name: "kw_thermal", label: "Kw Thermal", type: number },
    { name: "kw_electrical", label: "Kw Electrical", type: number },
    { name: "capacity_ton", label: "Capacity (ton)", type: number },
    { name: "efficiency", label: "Efficiency", type: number },
    { name: "number_of_compressors", label: "Number of compressors", type: number, integer: true, group: "compressors" },
    { name: "number_of_indoor_fans", label: "Number of indoor fans", type: number, integer: true, group: "indoor_fans" },
    { name: "number_of_outdoor_fans", label: "Number of outdoor fans", type: number, integer: true, group: "outdoor_fans" },
    { name: "coverage_area", label: "Coverage Area", type: number },
    { name: "capacity_cfm", label: "Capacity (CFM)", type: number },
    { name: "light_intensity", label: "Light Intensity", type: number },
    { name: "refrigerant_type", label: "Refrigerant Type / Charge", type: text },
  ],
  "AC - VAV": [
    { name: "actuator_type", label: "Actuator Type", type: text },
    { name: "related_current", label: "Related Current", type: number },
    { name: "voltage", label: "Voltage", type: number },
    { name: "coverage_area", label: "Coverage Area", type: number },
    { name: "room_size", label: "Room Size", type: number },
    { name: "capacity_cfm", label: "CFM", type: number },
    { name: "light_intensity", label: "Light Intensity", type: text },
    { name: "vav_width", label: "VAV's Width", type: number },
    { name: "vav_length", label: "VAV's Length", type: number },
  ],
  Pump: [
    { name: "motor_capacity", label: "Motor Capacity (KWH/HP)", type: number },
    { name: "voltage", label: "Voltage", type: number },
    { name: "rated_current", label: "Rated Current", type: number },
    { name: "flow_m3h", label: "Flow (M3/h)", type: number },
    { name: "rated_flow_rate_m3h", label: "Rated Flow Rate (m^3/h)", type: number },
    { name: "rated_rpm", label: "Rated RPM", type: number },
    { name: "connection_type", label: "Connection type", type: text },
    { name: "max_operating_pressure", label: "Max. Operating Pressure", type: number },
    { name: "control_type", label: "Control Type", type: text },
    { name: "head_m3", label: "Head (M^3)", type: number },
    { name: "max_water_temp", label: "Max Water Temp", type: number },
  ],
  Generator: [
    { name: "rated_capacity", label: "Rated Capacity", type: number },
    { name: "rated_voltage", label: "Rated Voltage", type: number },
    { name: "max_rated_current", label: "Max/Rated Current", type: number },
    { name: "rated_power_factor", label: "Rated Power Factor", type: number },
    { name: "rated_frequency", label: "Rated Frequency", type: number },
    { name: "fuel_tank_capacity", label: "Fuel Tank Capacity", type: number },
    { name: "fuel_type", label: "Fuel Type", type: text },
  ],
  "Solar System": [
    { name: "total_pv_capacity_dc", label: "Total PV Capacity (DC)", type: number },
    { name: "inverter_ac_rating", label: "Inverter AC Rating", type: number },
    { name: "tilt_azimuth_angles", label: "Tilt & Azimuth Angles", type: number },
    { name: "panel_size", label: "Panel Size", type: number },
    { name: "connection_type", label: "Connection Type", type: text },
    { name: "battery_capacity", label: "Battery Capacity", type: number },
  ],
  "Water Tank": [
    { name: "tank_type", label: "Type", type: text },
    { name: "shape", label: "Shape", type: text },
    { name: "length", label: "Length", type: number },
    { name: "width", label: "Width", type: number },
    { name: "height", label: "Height", type: number },
    { name: "location", label: "Location", type: text },
  ],
};

export const getOperationalFieldsForAsset = (category, assetType) => {
  if (category === "AC" && assetType === "AC - VAV") {
    return OPERATIONAL_FIELD_DEFINITIONS["AC - VAV"];
  }
  return OPERATIONAL_FIELD_DEFINITIONS[category] || [];
};
